import { TmFormElement } from '@root/packages/lit-sdk/src';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { live } from 'lit/directives/live.js';
import { tagName } from '../../helpers';
import { styles } from './toggle.styles';

const tag = tagName('toggle');

@customElement(tag)
export class ToggleComponent extends TmFormElement {
  static override styles = styles;

  protected override inputTemplate() {
    return html`<label for="inputElement" class="switch">
      <slot></slot>
      <input
        id="inputElement"
        ?disabled=${this.disabled}
        ?required=${this.required}
        ?readonly=${this.readonly}
        .indeterminate=${live(this.indeterminate)}
        .checked=${this.checked}
        .value=${this.value}
        @input=${this.handleInput}
        @change=${this.handleChange}
        type="checkbox"
      />
      <span class="slider">
        <span class="slider-thumb">
          <a-icon name="check"></a-icon>
        </span>
      </span>
      <slot name="after"></slot>
    </label>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-toggle': ToggleComponent;
  }
}
